<template>
    <base-dialog :loading="loading" :value="dialog" :title="dialogTitle" :width="480" :fullscreen="isMobile" @input="onDialogInput" @close="hide">
        <v-row dense>
            <v-col cols="12">
                <kimsa-date-picker :label="$t('common.date')" solo flat dense force-value color="secondary"
                    @change="date = $event" :value="date" />
            </v-col>
            <v-col cols="12">
                <kimsa-text-field :label="$t('common.duration')" @change="duration = $event" :value="duration" dense
                    no-elevation />
            </v-col>
            <v-col cols="12">
                <div class="field-label">{{ $t('common.drove') }}</div>
                <kimsa-segmented :items="yesNoItems" :value="drove" :columns="2" @change="drove = $event" />
            </v-col>
            <v-col cols="12">
                <div class="field-label">{{ $t('common.was_stressful') }}</div>
                <kimsa-segmented :items="yesNoItems" :value="wasStressful" :columns="2" @change="wasStressful = $event" />
            </v-col>
        </v-row>
        <template #footer>
            <v-btn class="footer-btn" depressed block :disabled="disabled" @click="save" :loading="loading">
                {{ $t('common.save') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>
import { db, Timestamp } from "@/utils/Firebase";
import { sendMessage, MESSAGE_COLORS } from "@/utils/Messages";
import KimsaDatePicker from "@/components/common/inputs/KimsaDatePicker";
import KimsaTextField from "@/components/common/inputs/KimsaTextField.vue";
import KimsaSegmented from "@/components/common/inputs/KimsaSegmented.vue";
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "TravelFormDialog",
    components: { KimsaDatePicker, KimsaTextField, KimsaSegmented, BaseDialog },
    props: {
        coachId: {
            type: String,
            default: null,
        },
        studentId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            date: null,
            duration: '',
            drove: null,
            wasStressful: null,
        }
    },
    computed: {
        dialogTitle(vm = this) {
            return `${vm.$t('common.add')} ${vm.$t('common.travel')}`
        },
        yesNoItems(vm = this) {
            return [
                { name: vm.$t('common.yes'), value: true },
                { name: vm.$t('common.no'), value: false },
            ]
        },
        disabled(vm = this) {
            return !vm.date || !vm.duration || vm.drove === null || vm.wasStressful === null
        },
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onDialogInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.date = null
            vm.duration = ''
            vm.drove = null
            vm.wasStressful = null
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                await db.collection('activities').add({
                    studentId: vm.studentId,
                    coachId: vm.coachId,
                    type: 'travel',
                    date: vm.date,
                    duration: vm.duration,
                    drove: vm.drove,
                    wasStressful: vm.wasStressful,
                    createdAt: Timestamp.now(),
                })

                await vm.sendMessageToCoach()
                vm.toast(vm.$t('common.travel_sent'))

                vm.hide()
            })
        },
        async sendMessageToCoach() {
            const vm = this

            let yes = vm.$t('common.yes')
            let no = vm.$t('common.no')
            let message = `${vm.$t('common.recorded_travel')} \n${vm.$t('common.date')}: ${vm.$moment(vm.date).format('DD-MM-YYYY')} \n${vm.$t('common.duration')}: ${vm.duration} \n${vm.$t('common.drove')} ${vm.drove ? yes : no} \n${vm.$t('common.was_stressful')} ${vm.wasStressful ? yes : no}`

            let studentId = vm.studentId
            let coachId = vm.coachId

            await sendMessage({ message, from: studentId, color: MESSAGE_COLORS.travel }, coachId, studentId)
        },
    },
}
</script>

<style scoped>
.field-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    margin-bottom: 6px;
}

.footer-btn.v-btn {
    height: 52px !important;
    border-radius: 0 !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    box-shadow: none !important;
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}

.footer-btn.v-btn.v-btn--disabled {
    background: var(--v-surface2-base) !important;
    color: var(--v-txtMuted-base) !important;
}
</style>
